const workflowMutation = {
  setModalData(state, { params, tag, status }) {
    state.modalData = [];

    if (tag == "rename") {
      if (status == "open") {
        state.modalData = params;
        state.renameModal = true;
      }
      if (status == "close") {
        state.renameModal = false;
      }
    }

    if (tag == "move") {
      if (status == "open") {
        state.modalData = params;
        state.moveModal = true;
      }
      if (status == "close") {
        state.moveModal = false;
      }
    }

    if (tag == "auth") {
      if (status == "open") {
        state.modalData = params;
        state.authModal = true;
      }
      if (status == "close") {
        state.authModal = false;
        state.modalData = [];
      }
    }
  },
  setAuthModal(state, { params, status }) {
    console.log(status)
    state.authModal = status;

    if(status){
      state.modalData = params;
    } else {
      state.modalData = 0;
    }
  },

  setGroups(state, groups) {
    state.groups = groups;
  },
  setWorkflows(state, workflows) {
    state.workflows = workflows;
  },
  setApps(state, apps) {
    state.apps = apps;
  },
  setWorkflowDetailHistory(state, history) {
    state.workflowDetailHistory = history;
  },
  setWorkflowDetailHistorys(state, historys) {
    state.workflowDetailHistorys = historys;
  },
  setApiHistorys(state, historys) {
    state.apiHistorys = historys;
  },
  setConnections(state, connections) {
    state.connections = connections;
  },
  setTriggers(state, triggers) {
    state.triggers = triggers;
  },
  setActions(state, actions) {
    state.actions = actions;
  },
  setApp(state, app) {
    state.app = app;
  },
  setApi(state, { api, index }) {
    state.api = api;
    state.workflowsS[index].api.apiName = api.apiName;
    state.workflowsS[index].api.versionCode = api.versionCode;
    state.workflowsS[index].api.apiKey = api.apiKey;
    state.workflowsS[index].api.apiType = api.apiType;
  },
  setWorkflow(state, { workCode, groupCode, schema, workflow }) {
    state.workflowName = schema.workflowName;
    state.nowWorkCode = workCode;
    state.groupCode = groupCode;
    state.workflowsS = schema.workflows;
    state.workflow = workflow;
  },
  setApiTest(state, { api, index }) {
    state.api = api;
    state.workflowsS[index].api.apiName = api.apiName;
    state.workflowsS[index].api.apiKey = api.apiKey;
    state.workflowsS[index].api.apiType = api.apiType;
  },
  setData(state, params) {
    state.appCode = params.appCode;
    state.appName = params.appName;
  },
  setAppInfo(state, params) {
    state.appCode = params.appCode;
    state.appName = params.appName;
  },
  setBuildWorkflows(state, obj) {
    state.workflowsS = obj;
  },
  setBuildAppNames(state, names) {
    state.appNames = names;
  },
  setChangeApp(state, { app, index }) {
    state.appNames[index].code = app.appCode;
    state.appNames[index].name = app.appName;
  },
  setSourceTriggerSchema(state, api) {
    state.sourceTriggerSchemas.push(api.apiSchema);
    // state.setCheck1 = true
  },
  setNowWorkName(state, name) {
    state.nowWorkName = name;
  },
  setWorkCode(state, code) {
    state.nowWorkCode = code;
  },
  setWorkflowName(state, name) {
    state.workflowName = name;
  },
  setResetData(state, { params, tag }) {
    if (tag == "workflow") {
      state.workflowsS = [];
      state.workflow = [];
      state.workflowName = "워크플로우";
      (state.triggers = []), (state.actions = []), (state.apis = []);
    }

    if (tag == "changeApp") {
      (state.workflowsS[params.index].api.apiCode = ""),
        (state.workflowsS[params.index].api.apiKey = ""),
        (state.workflowsS[params.index].api.apiName = "");
    }
  },
  setApis(state, apis) {
    state.apis = apis;
  },
  setGroupCode(state, code) {
    state.groupCode = code;
  },
  setResponse(state, params) {
    state.workflowsS[params.index].api.test.response.source = params.result;
    console.log("setResponse : ", state.workflowsS[params.index].api.test.response.source)
  },
  setWorkflowCode(state, code) {
    state.workflowCode = code;
  },
  setWorkflowForm(state, form) {
    state.workflowsS = form
  }
};

export default workflowMutation;
